import { AxiosRequestConfig } from 'axios';
import instance, { PPR_API_URL } from 'api';
import { IJournalEquipment, IJournalEquipmentItem, IResponsiblePersonList } from './interfaces';

export const loadJournalEquipment = (realEstateId: string) => {
  return instance(true, PPR_API_URL)
    .get<IJournalEquipment>('/journalEquipment/' + realEstateId)
    .then((response) => response.data);
};

export const createJournalEquipmentItem = (journalEquipmentId: number, journalEquipmentItem: IJournalEquipmentItem) => {
  return instance(true, PPR_API_URL)
    .post<IJournalEquipmentItem>(`/journalEquipment/${journalEquipmentId}/item/create`, journalEquipmentItem)
    .then((response) => response.data);
};

export const createJournalEquipmentItemWithTypeTechnicalRoom = (
  journalEquipmentId: number,
  typeTechnicalRoomId: number,
  journalEquipmentItem: IJournalEquipmentItem,
) => {
  return instance(true, PPR_API_URL)
    .post<IJournalEquipmentItem>(
      `/journalEquipment/${journalEquipmentId}/${typeTechnicalRoomId}/item/create`,
      journalEquipmentItem,
    )
    .then((response) => response.data);
};

export const updateJournalEquipmentItem = (journalEquipmentId: number, journalEquipmentItem: IJournalEquipmentItem) => {
  return instance(true, PPR_API_URL)
    .post<IJournalEquipmentItem>(
      `/journalEquipment/${journalEquipmentId}/item/${journalEquipmentItem.journalEquipmentItemId}/edit`,
      journalEquipmentItem,
    )
    .then((response) => response.data);
};

export const updateJournalEquipmentItemWithTypeTechnicalRoom = (
  journalEquipmentId: number,
  typeTechnicalRoomId: number,
  journalEquipmentItem: IJournalEquipmentItem,
) => {
  return instance(true, PPR_API_URL)
    .post<IJournalEquipmentItem>(
      `/journalEquipment/${journalEquipmentId}/${typeTechnicalRoomId}/item/${journalEquipmentItem.journalEquipmentItemId}/edit`,
      journalEquipmentItem,
    )
    .then((response) => response.data);
};

export const createResponsiblePersonList = (responsiblePersonList: IResponsiblePersonList) => {
  return instance(true, PPR_API_URL)
    .post(`/journalEquipment/create`, responsiblePersonList)
    .then((response) => response.data);
};

export const updateResponsiblePersonList = (realEstateId: string, responsiblePersonList: IResponsiblePersonList) => {
  return instance(true, PPR_API_URL)
    .post(`/journalEquipment/update/` + realEstateId, responsiblePersonList)
    .then((response) => response.data);
};

export const deleteJournalEquipmentItem = (journalEquipmentId: number, journalEquipmentItem: IJournalEquipmentItem) => {
  return instance(true, PPR_API_URL)
    .post<IJournalEquipmentItem>(
      `/journalEquipment/${journalEquipmentId}/item/${journalEquipmentItem.journalEquipmentItemId}/delete`,
    )
    .then((response) => response.data);
};

export const changeJournalEquipmentStatus = (journalEquipmentId: number, agreement: boolean, comment?: string) => {
  return instance(true, PPR_API_URL)
    .post(`/journalEquipment/${journalEquipmentId}/agreement`, { agreement, comment })
    .then((response) => response.data);
};

export const exportXls = (realEstateId: string) => {
  return instance(true, PPR_API_URL)
    .post(`/journalEquipment/${realEstateId}/exportXls`, null, { responseType: 'blob' })
    .then((response) => response.data);
};

export const exportPdf = (realEstateId: string) => {
  return instance(true, PPR_API_URL)
    .post(`/journalEquipment/${realEstateId}/exportPdf`, null, { responseType: 'blob' })
    .then((response) => response.data);
};

export const getUsers = (search: string | null, config: AxiosRequestConfig = {}) => {
  return instance()
    .post('/users/list', search ? { search } : {}, config)
    .then((response) => response.data);
};

export const updateEquipmentStatusToChecked = (journalEquipmentItemId: number) => {
  return instance(true, PPR_API_URL)
    .post(`/journalEquipment/${journalEquipmentItemId}/updateOnChecked`)
    .then((response) => response.data);
};

export const writeOffJournalEquipmentItem = (payload: { journalEquipmentItemId: number; countWrittenOff: number }) => {
  return instance(true, PPR_API_URL)
    .post('/journalEquipment/writtenOffJournalEquipmentItem', payload)
    .then((response) => response.data);
};

export const createEquipmentReplacement = (
  journalEquipmentId: number,
  typeTechnicalRoomId: number,
  journalEquipmentItem: IJournalEquipmentItem,
) => {
  return instance(true, PPR_API_URL)
    .post(
      `/journalEquipment/${journalEquipmentId}/${typeTechnicalRoomId}/item/createEquipmentReplacement`,
      journalEquipmentItem,
    )
    .then((response) => response.data);
};
